import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';


@JsonObject('model.time_card.VacationStats')
export class VacationStats extends AbstractModel {

    @JsonProperty(Number, 'availableSickDays')
    availableSickDays: number;

    @JsonProperty(Number, 'accruedVacationDays')
    accruedVacationDays: number;

    @JsonProperty(Number, 'availableVacationDays')
    availableVacationDays: number;

    @JsonProperty(Number, 'accruedSickDays')
    accruedSickDays: number;

    @JsonProperty(Number, 'usedSickDaysTotal')
    usedSickDaysTotal: number;

    @JsonProperty(Number, 'usedSickDaysApproved')
    usedSickDaysApproved: number;

    @JsonProperty(Number, 'carryoverSickDays')
    carryoverSickDays: number;

    @JsonProperty(Number, 'carryoverVacationDays')
    carryoverVacationDays: number;

    @JsonProperty(Number, 'correctionSickDays')
    correctionSickDays: number;

    @JsonProperty(Number, 'correctionVacationDays')
    correctionVacationDays: number;

    @JsonProperty(Number, 'usedUnpaidVacationDaysApproved')
    usedUnpaidVacationDaysApproved: number;

    @JsonProperty(Number, 'usedUnpaidVacationDaysTotal')
    usedUnpaidVacationDaysTotal: number;

    @JsonProperty(Number, 'usedVacationDaysTotal')
    usedVacationDaysTotal: number;

    @JsonProperty(Number, 'usedVacationDaysApproved')
    usedVacationDaysApproved: number;

    @JsonProperty(Number, 'workedHrs')
    workedHrs: number;

}